import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AuthorizationService } from "../components/authorization/authorization.service";
import { DTFHomepageService } from "../components/dtfhomepage/dtfhomepage.service";
import { Banner } from "../shared/models/banner";
import { APP_CONSTANTS } from "../utils/app-constants";
import { TranslateUtil } from "../utils/translate-util";
import { WindowRef } from "../utils/window";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { SharedTranslateModule } from "../utils/sharedTranslateModule";



@Component({
    selector: 'alertpage',
    imports: [SharedTranslateModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatSortModule
    ],
    templateUrl: './alert.component.html',
    providers: []
})

export class AlertPageComponent implements OnInit {
  title = 'Content Section of the Page';
  router: Router;
  path = '';
  token: string;
  brandId: string;
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  usUrl: string;
  caUrl: string;
  azURL: string;
  agentview: string;
  environment:string;
  agentId: string;
  bodyLoaded = false;
  dbLoaded = false;
  isFrench = false;
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  ciamId = sessionStorage.getItem('loginID');


  constructor(router: Router, private dtfhomepageService: DTFHomepageService, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil

  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
  }
  
  ngOnInit() {
    this.environment=sessionStorage.getItem('environment');
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    const language = (window as any).mbfs.language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
    this.brandId = sessionStorage.getItem('brandId');
    this.token = sessionStorage.getItem('ciamToken');

    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.currentCountry = val;
    });
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada

    this.getAlerts();
  }
  
  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  private parseDate(value: string | Date | null | undefined): Date | null {
    if (!value) {
      return null;
    }

    const parsedDate = value instanceof Date ? value : new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

  private isAlertActiveNow(alert: Banner): boolean {
    const now = new Date();
    const startDate = this.parseDate(alert.startDate);
    const endDate = this.parseDate(alert.endDate);

    if (!startDate || !endDate) {
      return false;
    }

    return now >= startDate && now <= endDate;
  }

  getAlerts() {
    this.dtfhomepageService.getAlerts().subscribe((res) => {
        this.dbData = false;
        for (var i = 0; i < res.length; i++) {
        if( this.currentCountry === 'CA'){
          if (res[i].bannerType === 'Alert' &&  res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
          res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA' && this.isAlertActiveNow(res[i])) {
          this.alerts = res[i];
          this.dbData = true;
           }
        }
        else{
          if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US' && this.isAlertActiveNow(res[i])) {
            this.alerts = res[i];
            this.dbData = true;
          }
        }
        }
      });
  }

  }
  

